import React, { useEffect, useState } from "react";
import { api, fmt } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";

const METHOD = { cash: "Nakit", card: "Kredi Kartı", transfer: "Havale" };

export default function Payments() {
    const [items, setItems] = useState([]);
    useEffect(() => {
        api.get("/payments").then((r) => setItems(r.data));
    }, []);
    return (
        <div data-testid="payments-page">
            <h1 className="text-3xl font-bold text-slate-900">Ödemeler</h1>
            <p className="text-slate-600 mt-1 mb-8">
                Son 200 ödeme kaydı (en yeni önce)
            </p>
            <Card>
                <CardContent className="p-0">
                    <table className="w-full">
                        <thead>
                            <tr className="border-b bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-600">
                                <th className="px-6 py-3">Tarih</th>
                                <th className="px-6 py-3">Yöntem</th>
                                <th className="px-6 py-3">Not</th>
                                <th className="px-6 py-3 text-right">Tutar</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((p) => (
                                <tr
                                    key={p.id}
                                    className="border-b hover:bg-slate-50"
                                >
                                    <td className="px-6 py-4 text-sm text-slate-500">
                                        {p.created_at?.slice(0, 10)}
                                    </td>
                                    <td className="px-6 py-4">
                                        {METHOD[p.method] || p.method}
                                    </td>
                                    <td className="px-6 py-4 text-slate-600">
                                        {p.note || "-"}
                                    </td>
                                    <td className="px-6 py-4 text-right mono font-semibold text-emerald-700">
                                        {fmt(p.amount, p.currency)}
                                    </td>
                                </tr>
                            ))}
                            {items.length === 0 && (
                                <tr>
                                    <td
                                        colSpan={4}
                                        className="text-center text-slate-500 py-12"
                                    >
                                        Henüz ödeme kaydı yok.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </CardContent>
            </Card>
        </div>
    );
}
